import React from 'react';
import OpenInNewLink from '../../libs/react-components-admin/link/open-in-new-link';
import Section from '../../libs/react-components-admin/section/section';

const Demo = () => {

  return <>
    <Section title="On Shopify" className="mb-4">
      <div className="row">
        <div className="col-auto">
          You can install our form builder via the <OpenInNewLink href="https://apps.shopify.com/custom-forms">appstore</OpenInNewLink>.
        </div>
      </div>
    </Section>
    <Section title="For other platforms">
      <div className="row">
        <div className="col-auto">
          Please get in touch (<a href="mailto:forms@acerill.com">forms@acerill.com</a>) and we will help you get setup, for free.
        </div>
        <div className="w-100"/>
        <div className="col-auto text-muted" style={{fontSize: '0.9em'}}>
          Note: we do not have a sales department, you will be in touch directly with a developer.
        </div>
      </div>
    </Section>
  </>;

};

export default Demo;